import { useEffect } from "react"
import axios from "axios"
import api from "../api"
import { getSession, getToken } from "../auth"

// An isolated client keeps optional telemetry failures from triggering the
// application's retry, logout or notification interceptors.
const accessApi = axios.create({ baseURL: api.defaults.baseURL, timeout: 3000 })

export const registerModuleAccess = (module, kind = "access") => {
    if (!module || (kind === "access" && document.visibilityState !== "visible"))
        return
    try {
        const user = getSession()
        const token = getToken()
        if (!token || !user?.id || !user?.profile?.enterprise?.id)
            return
        accessApi.post("api/module-access/", { module, kind }, {
            headers: { Authorization: `Bearer ${token}` },
        }).catch(() => {})
        return true
    } catch (error) {
        // Missing/invalid local session must never interfere with navigation.
    }
}

export const registerModuleUsage = module => registerModuleAccess(module, "usage")

const useModuleAccess = (module) => {
    useEffect(() => {
        if (!module)
            return

        let registered = false
        const registerAccess = () => {
            if (registered || document.visibilityState !== "visible")
                return
            registered = Boolean(registerModuleAccess(module))
        }

        registerAccess()
        document.addEventListener("visibilitychange", registerAccess)
        return () => document.removeEventListener("visibilitychange", registerAccess)
    }, [module])
}

export default useModuleAccess
